<template>
    <div class="lg:w-5/6 w-full">
        <div class="mb-3">
            <div class="mb-2">
                <div class="font-bold text-sm">{{ $t('organization_payments.invoice_info') }}</div>
                <p class="help-block my-0" v-html="$t('organization_payments.invoice_info_details')"></p>
            </div>
            <form @submit.prevent="onSubmit" @keydown="form.errors.forget($event.target.name)">
                <div class="flex flex-row">
                    <div class="flex-1 mb-3 mr-3" :class="{ 'has-error' : form.errors.has('bill_first_name') }">
                        <label class="mb-1" for="bill_first_name">{{ $t('globals.first_name') }}</label>
                        <input class="form-control" id="bill_first_name" name="bill_first_name" type="text" :placeholder="$t('sign_up.first_name_placeholder')" required v-model="form.bill_first_name" />
                        <p class="help-block" v-if="form.errors.has('bill_first_name')" v-text="form.errors.get('bill_first_name')"></p>
                    </div>
                    <div class="flex-1 mb-3" :class="{ 'has-error' : form.errors.has('bill_last_name') }">
                        <label class="mb-1" for="bill_last_name">{{ $t('globals.last_name') }}</label>
                        <input class="form-control" id="bill_last_name" name="bill_last_name" type="text" :placeholder="$t('sign_up.last_name_placeholder')" required v-model="form.bill_last_name" />
                        <p class="help-block" v-if="form.errors.has('bill_last_name')" v-text="form.errors.get('bill_last_name')"></p>
                    </div>
                </div>
                <div class="lg:w-3/4 mb-3" :class="{ 'has-error' : form.errors.has('bill_email') }">
                    <label class="mb-1" for="bill_email">{{ $t('auth.email') }}</label>
                    <input class="form-control" id="bill_email" name="bill_email" type="email" :placeholder="$t('sign_up.email_placeholder')" required v-model="form.bill_email" />
                    <p class="help-block" v-if="form.errors.has('bill_email')" v-text="form.errors.get('bill_email')"></p>
                </div>
                <div class="mb-3">
                    <div class="flex flex-row">
                        <div class="flex-1 mr-3" :class="{ 'has-error' : form.errors.has('bill_country_code') }">
                            <label class="mb-1" for="bill_country_code">{{ $t('globals.country') }}</label>
                            <select class="custom-select" id="bill_country_code" name="bill_country_code" required v-model="form.bill_country_code" @change="form.errors.forget($event.target.name)">
                                <option v-for="country in countries" :value="country.iso_3166_2">{{ country.name }}</option>
                            </select>
                            <p class="help-block" v-if="form.errors.has('bill_country_code')" v-text="form.errors.get('bill_country_code')"></p>
                        </div>
                        <div class="flex-1" :class="{ 'has-error' : form.errors.has('bill_state') }">
                            <label class="mb-1" for="bill_state">{{ $t('organization_payments.state') }}</label>
                            <input class="form-control" id="bill_state" name="bill_state" type="text" :placeholder="$t('organization_payments.state_placeholder')" required v-model="form.bill_state" />
                            <p class="help-block" v-if="form.errors.has('bill_state')" v-text="form.errors.get('bill_state')"></p>
                        </div>
                    </div>
                </div>
                <div class="mb-3" :class="{ 'has-error' : form.errors.has('bill_address') }">
                    <label class="mb-1" for="bill_address">{{ $t('organization_payments.bill_address') }}</label>
                    <input class="form-control" id="bill_address" name="bill_address" type="text" :placeholder="$t('organization_payments.address_placeholder')" required v-model="form.bill_address" />
                    <p class="help-block" v-if="form.errors.has('bill_address')" v-text="form.errors.get('bill_address')"></p>
                </div>
                <div class="pt-6 mb-3">
                    <div class="flex flex-row">
                        <div class="flex-1 mr-3" :class="{ 'has-error' : form.errors.has('bill_company_name') }">
                            <label class="mb-1" for="bill_company_name">{{ $t('organization_payments.company') }} <span class="italic text-gray-400 tracking-tighter">{{ $t('globals.optional') }}</span></label>
                            <input class="form-control" id="bill_company_name" name="bill_company_name" type="text" :placeholder="$t('organization_payments.company_placehoder')" v-model="form.bill_company_name" />
                            <p class="help-block" v-if="form.errors.has('bill_company_name')" v-text="form.errors.get('bill_company_name')"></p>
                        </div>
                        <div class="flex-1" :class="{ 'has-error' : form.errors.has('bill_tax_id') }">
                            <label class="mb-1" for="bill_tax_id">{{ $t('organization_payments.tax_id') }} <span class="italic text-gray-400 tracking-tighter">{{ $t('globals.optional') }}</span></label>
                            <input class="form-control" id="bill_tax_id" name="bill_tax_id" type="text" v-model="form.bill_tax_id" />
                            <p class="help-block" v-if="form.errors.has('bill_tax_id')" v-text="form.errors.get('bill_tax_id')"></p>
                        </div>
                    </div>
                </div>
                <div class="lg:w-1/2 mb-3" :class="{ 'has-error' : form.errors.has('bill_registration_number') }">
                    <label class="mb-1" for="bill_registration_number">{{ $t('organization_payments.registration_number') }} <span class="italic text-gray-400 tracking-tighter">{{ $t('globals.optional') }}</span></label>
                    <input class="form-control" id="bill_registration_number" name="bill_registration_number" type="text" v-model="form.bill_registration_number" />
                    <p class="help-block" v-if="form.errors.has('bill_registration_number')" v-text="form.errors.get('bill_registration_number')"></p>
                </div>
                <p class="help-block">{{ $t('organization_payments.company_fields_help_block') }}</p>
                <div class="pt-2">
                    <button class="btn btn-primary" :disabled="form.errors.any()" type="submit">{{ $t('globals.save_changes') }}</button>
                </div>
            </form>
        </div>
        <div class="pb-2 pt-1">
            <hr>
        </div>
        <div>
            <div class="mb-2">
                <div class="font-bold text-sm">{{ $t('organization_payments.payment_info') }}</div>
            </div>
            <template v-if="isPayingByBankTransfer">
                <div class="bg-gray-200 border border-primary-500 flex flex-1 items-center px-2 py-6px rounded text-primary-500">
                    <span class="icon icon-info-circle icon-fw mr-1"></span>
                    <div>{{ $t('organization_payments.paying_by_bank_transfer_info') }}</div>
                </div>
            </template>
            <template v-else>
                <div class="flex flex-row mb-3">
                    <div v-if="pendingCardDetails" class="bg-gray-200 border border-warning-500 flex flex-1 items-center px-2 py-6px text-warning-500 rounded">
                        <span class="icon icon-spinner icon-fw spin mr-1"></span>
                        <div v-html="$t('organization_payments.pending_card', {
                            linkOpen: '<a class=&quot;ml-1 redo&quot; href=&quot;/organization/payments#billing-settings&quot; onclick=&quot;window.location.reload();&quot;>',
                            linkClose: '</a>'
                        })"></div>
                    </div>
                    <div v-else class="bg-gray-200 border flex flex-1 items-center px-2 py-6px"
                        :class="[ creditCard ? 'border-r-0 border-primary-500 text-primary-500 rounded-l' : 'border-danger-500 text-danger-500 rounded' ]">
                        <template v-if="creditCard">
                            <span class="icon icon-info-circle icon-fw mr-1"></span>
                            <div v-html="$t('organization_payments.payment_info_details', {
                                emphasizedOpen: '<span class=&quot;font-semibold&quot;>',
                                emphasizedClose: '</span>',
                                last4Digits: creditCard.mask.replace(/\D+/g, ''),
                                expDate: formatDate(creditCard.expDate),
                            })"></div>
                        </template>
                        <template v-else>
                            <span class="icon icon-warning icon-fw mr-1"></span>
                            <div>{{ $t('organization_payments.no_payment_info') }}</div>
                        </template>
                    </div>
                    <div v-if="creditCard" class="btn-group inline-flex" role="group">
                        <template v-if="paymentProcessor === 'payu'">
                            <form method="post" :action="payuPaymentInfoFormAction">
                                <template v-for="[key, value] in Object.entries(payuPaymentInfoFormData)">
                                    <template v-if="Array.isArray(value)">
                                        <input v-for="singleValue in value" :name="key" :value="singleValue" type="hidden">
                                    </template>
                                    <input v-else :name="key" :value="value" type="hidden">
                                </template>
                                <button v-if="hasPaymentDetails" class="bg-gray-200 border-primary-500 btn focus:outline-none hover:bg-gray-400 rounded-none border-r-0" type="submit" v-tooltip="{ content: $t('organization_payments.edit_card') }">
                                    <span class="icon icon-pencil"></span>
                                </button>
                                <div v-else class="bg-gray-200 border-primary-500 btn focus:outline-none hover:bg-gray-400 rounded-none border-r-0 disabled" v-tooltip="{ content: $t('organization_payments.edit_payment_info_form_disabled_info'), placement: 'top' }">
                                    <span class="icon icon-pencil"></span>
                                </div>
                            </form>
                            <button @click="removeCard" class="bg-gray-200 border-primary-500 btn focus:outline-none hover:bg-gray-400" type="button" v-tooltip="{ content: $t('organization_payments.remove_card') }">
                                <span class="icon icon-trash"></span>
                            </button>
                        </template>
                        <template v-else-if="paymentProcessor === 'stripe'">
                            <template>
                                <form @submit.prevent="createStripeCheckoutSession">
                                    <button v-if="hasPaymentDetails" :disabled="stripeForm.busy" class="bg-gray-200 border-primary-500 btn focus:outline-none hover:bg-gray-400 rounded-none border-r-0" type="submit" v-tooltip="{ content: $t('organization_payments.edit_card') }">
                                        <span class="icon icon-pencil"></span>
                                    </button>
                                    <div v-else class="bg-gray-200 border-primary-500 btn focus:outline-none hover:bg-gray-400 rounded-none border-r-0 disabled" v-tooltip="{ content: $t('organization_payments.edit_payment_info_form_disabled_info'), placement: 'top' }">
                                        <span class="icon icon-pencil"></span>
                                    </div>
                                </form>
                            </template>
                            <button @click="removeCard" class="bg-gray-200 border-primary-500 btn focus:outline-none hover:bg-gray-400" type="button" v-tooltip="{ content: $t('organization_payments.remove_card') }">
                                <span class="icon icon-trash"></span>
                            </button>
                        </template>
                    </div>
                </div>
                <div v-if="creditCard === null && ! pendingCardDetails" class="pt-2">
                    <template v-if="paymentProcessor === 'payu'">
                        <form method="post" :action="payuPaymentInfoFormAction">
                            <template v-for="[key, value] in Object.entries(payuPaymentInfoFormData)">
                                <template v-if="Array.isArray(value)">
                                    <input v-for="singleValue in value" :name="key" :value="singleValue" type="hidden">
                                </template>
                                <input v-else :name="key" :value="value" type="hidden">
                            </template>
                            <button v-if="hasPaymentDetails" class="btn btn-primary" type="submit">
                                {{ $t('organization_payments.add_card') }}
                            </button>
                            <div v-else class="btn btn-primary disabled" v-tooltip="{ content: $t('organization_payments.payment_info_form_disabled_info'), placement: 'top' }">
                                {{ $t('organization_payments.add_card') }}
                                <span class="icon icon-question-circle icon-fw"></span>
                            </div>
                        </form>
                    </template>
                    <template v-else-if="paymentProcessor === 'stripe'">
                        <form @submit.prevent="createStripeCheckoutSession">
                            <button v-if="hasPaymentDetails" :disabled="stripeForm.busy" class="btn btn-primary" type="submit">
                                {{ $t('organization_payments.add_card') }}
                            </button>
                            <div v-else class="btn btn-primary disabled" v-tooltip="{ content: $t('organization_payments.payment_info_form_disabled_info'), placement: 'top' }">
                                {{ $t('organization_payments.add_card') }}
                                <span class="icon icon-question-circle icon-fw"></span>
                            </div>
                        </form>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { lightFormat, parseISO } from 'date-fns';

export default {
    props: {
        countries: {
            type: Array,
            required: true,
        },
        paymentProcessor: {
            type: String,
            required: true,
        },
        payuPaymentInfoFormData: {
            required: true,
        },
        pendingCardDetails: {
            type: Boolean,
            required: true,
        },
        isPayingByBankTransfer: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            payuPaymentInfoFormAction: '',
            form: new Form({
                bill_first_name: '',
                bill_last_name: '',
                bill_email: '',
                bill_country_code: '',
                bill_state: '',
                bill_address: '',
                bill_company_name: '',
                bill_tax_id: '',
                bill_registration_number: '',
            }),
            stripeForm: new Form({}),
            creditCard: null,
        };
    },

    created() {
        this.form.bill_first_name = window.Globals.user.organization.bill_first_name;
        this.form.bill_last_name = window.Globals.user.organization.bill_last_name;
        this.form.bill_email = window.Globals.user.organization.bill_email;
        this.form.bill_country_code = window.Globals.user.organization.bill_country_code;
        this.form.bill_state = window.Globals.user.organization.bill_state;
        this.form.bill_address = window.Globals.user.organization.bill_address;
        this.form.bill_company_name = window.Globals.user.organization.bill_company_name;
        this.form.bill_tax_id = window.Globals.user.organization.bill_tax_id;
        this.form.bill_registration_number = window.Globals.user.organization.bill_registration_number;

        this.payuPaymentInfoFormAction = `${window.Globals.payuEndpoint}/order/lu.php`;
        this.hasPaymentDetails = window.Globals.user.organization.bill_first_name &&
            window.Globals.user.organization.bill_last_name &&
            window.Globals.user.organization.bill_email &&
            window.Globals.user.organization.bill_country_code &&
            window.Globals.user.organization.bill_state &&
            window.Globals.user.organization.bill_address;

        if (this.hasPaymentDetails && window.Globals.user.organization.cc_mask && window.Globals.user.organization.cc_exp_date) {
            if (this.paymentProcessor === 'payu' && window.Globals.user.organization.cc_token && window.Globals.user.organization.cc_token_hash) {
                this.creditCard = {
                    brand: null,
                    token: window.Globals.user.organization.cc_token,
                    tokenHash: window.Globals.user.organization.cc_token_hash,
                    mask: window.Globals.user.organization.cc_mask,
                    expDate: window.Globals.user.organization.cc_exp_date,
                };
            } else if (this.paymentProcessor === 'stripe' && window.Globals.user.organization.stripe_customer_id && window.Globals.user.organization.stripe_payment_method_id) {
                this.creditCard = {
                    brand: window.Globals.user.organization.cc_brand,
                    token: null,
                    tokenHash: null,
                    mask: window.Globals.user.organization.cc_mask,
                    expDate: window.Globals.user.organization.cc_exp_date,
                };
            }
        }
    },

    methods: {
        onSubmit() {
            Globals.post('/api/v1/update-billing-info', this.form)
                .then(() => window.location.reload())
                .catch(error => {
                    if (error.message !== 'The given data was invalid.') {
                        window.toastr.clear();
                        window.toastr.error(this.$t('globals.unexpected_error'));
                    }
                });
        },

        removeCard() {
            Bus.$emit('showRemoveCardModal');
        },

        createStripeCheckoutSession() {
            Globals.post('/stripe/checkout-session', this.stripeForm)
                .then(response => window.location.href = response.url)
                .catch(error => {
                    if (error.message !== 'The given data was invalid.') {
                        window.toastr.clear();
                        window.toastr.error(this.$t('globals.unexpected_error'));
                    }
                });
        },

        formatDate(date) {
            return lightFormat(parseISO(date), 'MM/yy');
        },
    },
};
</script>
